/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 *      keep in sync with the code):
 *   role:      lib — resolves the resort (comprensorio) a private lesson is sold for
 *   exports:   defaultComprensorio(optionField, maestro)
 *   callers:   controllers/detail.js (_addPrivateCart), controllers/ski-instructor.js
 *              (_addPrivateCart)
 *   mirrors:   components/private-calendar.js setDefaultComp — same precedence, so the
 *              resort recorded in the cart is the one availability was fetched for
 *
 * A private lesson always belongs to a resort, and <PrivateCalendar> already picks one
 * for itself when nobody supplied it: it queries availability for
 * `maestro.localita[0]`, else the tenant's default private resort, else the first one.
 * That pick lives inside the component and never travels back to the host controller,
 * so the cart could be built with no resort at all while the customer had been looking
 * at a perfectly normal calendar. Deriving it here with the SAME precedence keeps the
 * two in step without making the cart depend on the host's boot-time seeding.
 */

/**
 * @param {object} optionField tenant `option_field` (session.option_field)
 * @param {object} [maestro]   the chosen instructor, when the customer picked one
 * @returns {string|null} resort name, or null when the tenant defines none
 */
export default function defaultComprensorio(optionField, maestro) {
  const localita = maestro?.localita;
  if (Array.isArray(localita) && localita.length > 0) {
    return localita[0];
  }

  const comprensori = optionField?.comprensori;
  if (!Array.isArray(comprensori)) {
    return null;
  }

  const cPrivate = comprensori.filter((item) => item.ecommerce_private === true);

  return cPrivate.find((item) => item.default === true)?.name || cPrivate[0]?.name || null;
}
